@import (reference) '../../../../../../../constants/spacing.module.less';

.banner {
  background-color: var(--grey-100);
  border-radius: 4px;
  padding: @space-12;
  align-items: flex-start;
  width: 100%;
  margin-bottom: @space-12;
  animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.sparkleIcon {
  color: var(--purple-8B5CF6);
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.bannerBody {
  flex: 1;
  min-width: 0;
}

.bannerTitle {
  flex: 1;
  font-weight: 500;
  color: var(--default--text-color--17);
  line-height: 20px;
}

.packageList {
  width: 100%;
}

.packageInfo {
  align-items: baseline;
  flex-wrap: wrap;
}

.morePackages {
  color: var(--grey-600);
  font-style: italic;
}

.packageName {
  font-weight: 600;
}

.packageDims {
  color: var(--grey-600);
}

.actionButton {
  height: 28px;
}

.rerunIcon {
  width: 12px;
  height: 12px;
  margin-right: @space-4;
}

.closeButton {
  flex-shrink: 0;
  padding: 0;
}

.closeIcon {
  width: 16px;
  height: 16px;
  color: var(--grey-600);
}
